<template>
  <modal
    ref="modalActions"
    modal-id="UpdatePersonalGoal"
    :is-full-screen="false"
  >
    <template v-slot:header>
      <update-personal-goal-header />
    </template>
    <div class="background padding-ml">
      <div class="text-container">
        <div>
          <span class="ri-bold-body"> כמה היית רוצה להוציא על {{ expenseCategory }} במהלך האתגר?</span>
        </div>
      </div>
      <amount-input
        :class="hasActiveCashflow ? 'margin-bottom-xs!important' : 'margin-bottom-l'"
        :value="personalGoal"
        :autofocus="false"
        @input="setPersonalGoal"
      />
      <div
        v-if="hasActiveCashflow"
        class="margin-bottom-l ri-small-body"
      >
        במהלך 3 השבועות האחרונים הוצאת בממוצע ₪{{ challengeGoal }}
        <span class="ri-small-bold-body">בקטגורית {{ expenseCategory }}</span>
      </div>
      <div class="sticky-button-wrapper">
        <riseup-button
          class="join-challenge-button"
          title="הצטרפות לאתגר"
          size="slim"
          :disabled="disabled"
          :action="action === ACTION.CREATE ? joinChallenge : updatePersonalGoal"
          :loading="loading"
        />
      </div>
    </div>
  </modal>
</template>

<script lang="ts" setup>
import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton/RiseupButton.vue';
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { isNil } from 'lodash';
import Modal, { ModalRef } from '../../layouts/Modal/Modal';
import UpdatePersonalGoalHeader from './UpdatePersonalGoalHeader.vue';
import { useChallengeStore } from '../../stores/challenge';
import { useRiseupAccountStore } from '../../stores/riseupAccount';
import Segment from '../../Segment';
import useUpdatePersonalGoalModal from '../../composables/useUpdatePersonalGoalModal';
import useToaster from '../../composables/useToaster';
import { ACTION } from './consts';

const { action } = useUpdatePersonalGoalModal();
const { showToaster } = useToaster();

const challengeStore = useChallengeStore();
const {
  loading,
  challengeGoal,
  expenseCategory,
} = storeToRefs(challengeStore);
const riseupAccountStore = useRiseupAccountStore();
const { hasActiveCashflow } = storeToRefs(riseupAccountStore);

const personalGoal = ref(challengeGoal.value);
function setPersonalGoal(newPersonalGoal: number) {
  personalGoal.value = newPersonalGoal;
}

const modalActions = ref<ModalRef | null>(null);

const disabled = computed(() => isNil(personalGoal.value));
async function joinChallenge() {
  try {
    await challengeStore.addParticipant(personalGoal.value);
    Segment.trackUserInteraction('UpdatePersonalGoal_Clicked');
    modalActions.value?.closeModal();
  } catch (e) {
    showToaster('קרתה תקלה, נסה שוב מאוחר יותר');
  }
}

async function updatePersonalGoal() {
  try {
    await challengeStore.updateParticipantPersonalGoal(personalGoal.value);
    Segment.trackUserInteraction('UpdatePersonalGoal_Clicked');
    modalActions.value?.closeModal();
  } catch (e) {
    showToaster('קרתה תקלה, נסה שוב מאוחר יותר');
  }
}

</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';

.background {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: $riseup-white;

  .text-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    gap:8px;
  }

  .sticky-button-wrapper {
    position: sticky;
    bottom: 0;
    width: 100%;
    background-color: $riseup-white;
    .join-challenge-button {
      height: 54px;
      width: 100%;
    }
  }

}
</style>
